import { Tab, Campaign } from "@shared/types/campaign";

export interface State {
    openCampaigns: Campaign[];
    tabs: Tab[];
    upcomingCampaigns: Campaign[];
    loading: boolean;
    error?: string;
    imagesLoaded: boolean;
}

export const initialState: State = {
    openCampaigns: [],
    tabs: [],
    upcomingCampaigns: [],
    loading: false,
    error: undefined,
    imagesLoaded: false,
};
